import {Injectable} from '@angular/core';
import {coalesce, FetchRequest, RequestOptions, RestResponse, RestService} from '@abydos-angular/core';
import {CrudApiInterface} from '@abydos-angular/store';
import {ApplicationVO, ApplicationListVO} from '../store/application.interfaces';
import {Observable} from 'rxjs';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';
@Injectable()
export class ApplicationRestService implements CrudApiInterface<ApplicationVO, ApplicationListVO> {
    private restPath = 'eventApplication/';

    constructor(private restService: RestService) {
    }

    add(payload: ApplicationVO, metaData?: {[key: string]: any}): Observable<RestResponse> {
        return this.restService.silentPost(coalesce(metaData?.['silentMode'], false), this.getRestPath(metaData) + this.getRestEndpoint(metaData, 'add'), payload, this.getOptions(metaData));
    }

    get(id: number, metaData?: {[key: string]: any}): Observable<RestResponse> {
        return this.restService.silentGet(coalesce(metaData?.['silentMode'], false), this.getRestPath(metaData) + this.getRestEndpoint(metaData, 'get') + '/' + id, this.getOptions(metaData));
    }

    list(fetchRequest: FetchRequest<ApplicationListVO>): Observable<RestResponse> {
        return this.restService.silentGet(coalesce(fetchRequest.metaData?.['silentMode']), this.getRestPath(fetchRequest.metaData) + this.getRestEndpoint(fetchRequest.metaData, 'list')
            , fetchRequest.convertToJsonParam(), this.getOptions(fetchRequest.metaData));
    }

    search(fetchRequest: FetchRequest<ApplicationListVO>): Observable<RestResponse> {
      return this.restService.silentPost(coalesce(fetchRequest.metaData?.['silentMode']), this.getRestPath(fetchRequest.metaData) + this.getRestEndpoint(fetchRequest.metaData, 'search')
        , fetchRequest, this.getOptions(fetchRequest.metaData));
    }

    remove(id: number, metaData?: {[key: string]: any}): Observable<RestResponse> {
        return this.restService.silentPost(coalesce(metaData?.['silentMode'], false), this.getRestPath(metaData) + this.getRestEndpoint(metaData, 'remove') + '/' + id, this.getOptions(metaData));
    }

    update(payload: ApplicationVO, metaData?: {[key: string]: any}): Observable<RestResponse> {
        return this.restService.silentPost(coalesce(metaData?.['silentMode'], false), this.getRestPath(metaData) + this.getRestEndpoint(metaData, 'update'), payload, this.getOptions(metaData));
    }

    private getRestPath(metaData: { [key: string]: any } | null | undefined) {
        return coalesce(metaData?.['restServicePath'], this.restPath);
    }

    private getRestEndpoint(metaData: { [key: string]: any } | null | undefined, defaultValue: string) {
        return coalesce(metaData?.['restServiceEndpoint'], defaultValue);
    }

    private getOptions(metaData: { [key: string]: any } | null | undefined): RequestOptions | undefined {
        let options: RequestOptions | undefined = undefined;
        if (isNotNullOrUndefined(metaData?.['handleError'])) {
          options = {handleError: metaData?.['handleError']};
        }
        return options;
    }
}
